import { Divider, Group, Modal } from '@mantine/core';
import { useFillOutRevisionDataProvider } from 'components/forms/revision/fill-out/data/FillOutRevisionDataProvider';
import { useCallback, useEffect } from 'react';
import { useDisclosure } from '@mantine/hooks';
import { useFillOutRevisionSaveDraftProvider } from 'components/forms/revision/fill-out/data/FillOutRevisionSaveDraftProvider';
import ChangeGroup from 'components/forms/revision/fill-out/modals/revision-changes-modal/ChangeGroup';
import Button from 'components/Button';

/**
 * Modal which displays the changes made to the revision.
 */
export default function RevisionChangesModal() {
  const { changes, acknowledgedChanges } = useFillOutRevisionDataProvider();
  const { saveDraft, loading } = useFillOutRevisionSaveDraftProvider();
  const [opened, { close }] = useDisclosure(changes.length > 0);

  const handleAcknowledge = useCallback(async () => {
    await saveDraft({ notify: false });
    acknowledgedChanges();
    close();
  }, [saveDraft, close, acknowledgedChanges]);

  useEffect(() => {
    if (changes.length === 0) {
      acknowledgedChanges();
    }
  }, [changes, acknowledgedChanges]);

  return (
    <Modal
      title="V reviznej správe nastali zmeny !"
      opened={opened}
      onClose={close}
      centered
      withCloseButton={false}
      closeOnClickOutside={false}
      closeOnEscape={false}
    >
      <Divider color="gray.2" />
      {changes.map((changeGroup, index) => (
        <ChangeGroup key={index} {...changeGroup} />
      ))}
      <Group position="right" pt={16}>
        <Button variant="primary" onClick={handleAcknowledge} loading={loading} data-autofocus>
          V poriadku, beriem na vedomie
        </Button>
      </Group>
    </Modal>
  );
}
